module.exports = __webpack_public_path__ + "img/set_screenshot.4958c306.jpg";